import { Button } from '@acies/ui';
import PropertiesPanelShowHideButtonEvent from './properties-panel-show-hide-button-event';

export default class PropertiesPanelShowHideButton extends Button {
	public constructor() {
		super();
		this.width = 38;
		this.icon = 'layout-right';
	}

	/**
	 * Answers the press with its own event.
	 *
	 * Super.clicked() is deliberately not called: Button answers a press with a ButtonEvent, and a listener above would hear both that and this one, without being able to tell which button the ButtonEvent came from.
	 */
	protected override clicked(): void {
		this.dispatchEvent(new PropertiesPanelShowHideButtonEvent());
	}
}
customElements.define('ac-properties-panel-show-hide-button', PropertiesPanelShowHideButton);
